import styled from "styled-components";

const Button = styled.button`
  border: 0;
  background-color: transparent;
  padding: 0;
  &:hover:not(:disabled) {
    cursor: pointer;
  }
  &:disabled {
    cursor: default;
  }
  &:focus {
    outline: none; /* 포커스시 테두리 제거 */
  }
`;

export default Button;